module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-gray-7d372b5407c5b8da6b02594a91a5284d.png";